<template>
  <v-app>
    <v-app-bar app dense color="secondary">
      <v-row>
        <v-col cols="2">
          <v-btn @click="back" v-show="isShowBack" text style="padding:0px;min-width:10px"><v-icon left>mdi-chevron-left</v-icon></v-btn>
        </v-col>
        <v-col class="text-center" style="line-height:40px;font-size:1.1em;font-weight:bold">{{appTitle}}</v-col>
        <v-col cols="2">
          <v-btn @click="backHome" v-show="isShowHome" text style="padding:0px;min-width:10px"><v-icon right>mdi-home-outline</v-icon></v-btn>
        </v-col>
      </v-row>
    </v-app-bar>

    <v-content>
      <router-view @app_info="setAppInfo" @show_alert="showAlert" @show_overlay="showOverlay" />
    </v-content>

    <v-overlay :opacity="0.6" :value="isBusy" class="text-center">
      <p><v-progress-circular indeterminate size="32"></v-progress-circular></p>
      <p style="margin-top:5px">読込中...</p>
    </v-overlay>

    <VAlert ref="alert" :options="alertOptions" @callback="alertCallback"></VAlert>
  </v-app>
</template>

<script>
//import HelloWorld from './components/HelloWorld';
import VAlert from '@/components/VAlert.vue'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'App',
  components: {
    //HelloWorld,
    VAlert
  },
  data() {
    return {
      appTitle: '',
      isShowBack: true,
      isShowHome: true,
      alertOptions: {
        message: '',
        title: '',
        callback: null,
        showCancel: false,
        showOk: true
      },
      isBusy: false
    }
  },
  computed: {
      ...mapState([ "app" ]),
  },
  mounted() {
    if(this.appTitle == '') {
      this.appTitle = this.AppName
    }
  },
  methods: {
    ...mapMutations([
        'setAppData'
    ]),
    back() {
      window.history.back()
    },
    backHome() {
      this.$router.push('/user_center');
    },
    setAppInfo(title, showBack = true, showHome = true) {
      this.appTitle = title
      this.isShowBack = showBack
      this.isShowHome = showHome
      this.checkMaintenance()
    },
    showAlert(msg, title = 'アラート', callback = null, options = {showCancel:false, showOk:true}) {
      this.alertOptions.message = msg
      this.alertOptions.title = title
      this.alertOptions.callback = callback
      if(options.showCancel != null) this.alertOptions.showCancel = options.showCancel
      if(options.showOk != null) this.alertOptions.showOk = options.showOk
      this.$refs.alert.open()
    },
    alertCallback(ret) {
      if(this.alertOptions.callback) {
        this.alertOptions.callback(ret)
      }
    },
    showOverlay(isShow = true) {
      this.isBusy = isShow
    },
    checkMaintenance() {
      let vapp = this;
      this.callApi(this, 'index', 'home', {}, function(data){
        if(data.status == 1) {
          vapp.setAppData(data)
          if(vapp.app.isMaintenance) {
            vapp.showAlert(vapp.app.maintenanceMsg, 'アラート', function(){
              if(vapp.$route.path != '/') {
                vapp.$router.push('/')
              }
            })
          }
        }
      });
    }
  }
};
</script>
